<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-select v-model="tableParams.channelId" />
      <el-input

        placeholder="请输入公司名称"
        v-model="tableParams.companyName"
        clearable
      ></el-input>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-if="tableParams.isTime"
          sortable
          prop="timeHour"
          label="上报时间"
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <span v-if="v.field === 'channelType'">{{
              channelTypeMap[scope.row[v.field]] || "-"
            }}</span>
            <div v-else-if="v.field === 'imageUrl'">
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                ref="popover"
              >
                <template #reference>
                  <el-image
                    :src="$imgURL + scope.row[v.field]"
                    error="-"
                    width="100"
                  >
                    <template #error>
                      <div class="image-slot">
                        <span>-</span>
                      </div>
                    </template>
                  </el-image>
                </template>
                <img
                  :src="$imgURL + scope.row[v.field]"
                  style="height: 250px"
                />
              </el-popover>
            </div>
            <span v-else-if="v.field === 'isEnable'">{{
              scope.row[v.field] ? "禁用" : "正常"
            }}</span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>

    <m-form @submit="toQuery" ref="form" title="渠道 " />
  </div>
</template>

<script>
import TableColumn from "@/components/TableColumn";
import SearchChannelSelect from "@/components/SearchChannelSelect";
import mForm from "./form";
import BaseDatePicker from "@/components/BaseDatePicker";
import initTableMixin from "@/mixins/initTable";
import { getSubjectInfo } from "@/api/manage/channel/channel";
export default {
  name: "Manage/channel/channel",
  components: {
    TableColumn,
    SearchChannelSelect,
    BaseDatePicker,
    mForm,
  },
  mixins: [initTableMixin],
  data() {
    return {
      channelTypeMap: {
        1: "CPM",
        2: "CPD",
        3: "通用",
      },
      statusList: [
        { value: 0, lable: "审核通过" },
        { value: 1, lable: "未通过" },
        { value: 2, lable: "未审核" },
      ],
      columns: [
        { field: "channelId", title: "渠道ID" },
        { field: "channelName", title: "渠道名称" },
        { field: "channelType", title: "渠道类型" },
        { field: "isEnable", title: "渠道状态" },
        { field: "ekey", title: "渠道密钥" },
        { field: "companyName", title: "公司名称" },
        { field: "imageUrl", title: "营业执照" },
        { field: "contactName", title: "联系人" },
        { field: "contactPhone", title: "联系电话" },
        { field: "mailBox", title: "联系邮箱" },
        { field: "taxPoint", title: "收益分成" },
        { field: "account", title: "账户" },
        { field: "createTime", title: "创建时间" },
      ],
      statusList: [],
    };
  },
  created() {
    getSubjectInfo().then((res) => {
      this.statusList = res.data;
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/account/channel/list";
      return true;
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime;
      this.tableParams.endTime = date.endTime;
    },
    add() {
      this.$refs.form.show();
    },
    update(row) {
      this.statusList.forEach((index) => {
        if (index.subjectId == row.subjectId) {
          row.subjectId = index.subjectName;
        }
      });
      this.$refs.form.show(row);
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
